import React, {PureComponent} from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from 'components/common/Table';
import TextField from 'components/common/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './styles.module.sass';
import {dateToDate, toMoney} from 'data/converter';
import Tooltip from '@material-ui/core/Tooltip';
import DateField from 'components/common/DateField';
import DateFieldRange from 'components/common/DateFieldRange';
import NumberField from 'components/common/NumberField';
//import isObject from 'lodash.isobject';
//import isEmpty from 'lodash.isempty';


class TableComponent extends PureComponent {
  valueFormatted = (value, {type, dict}) => {
    if (dict) {
      return dict[value];
    } else {
      switch (type) {
        case 'date':
          return dateToDate(value);
        case 'money':
          return toMoney(value);
        case 'bool':
          return value;
        case 'number':
        default:
          return value;
      }
    }
  };

  handlerOnChangeFilter = (flt) => {
    const { onChangeFilter } = this.props;
    /*
    let columnFields = {};
    for (let i = 0; i < columns.length; i++) {
      let column = columns[i];
      let field = column.field;
      columnFields[field] = true;
    }

    let filterKeys = Object.keys(flt);
    for (let i = 0; i < filterKeys.length; i++) {
      let filterKey = filterKeys[i];
      let fltValue = flt[filterKey];
      if (!columnFields[filterKey] || fltValue === null || fltValue === undefined || fltValue === '') {
        delete flt[filterKey];
      } else {
        if (isObject(fltValue)) {
          let fltValueKeys = Object.keys(fltValue);
          if (fltValueKeys.length <= 0) {
            delete flt[filterKey];
          } else {
            fltValueKeys.forEach((key) => {
              let v = fltValue[key];
              if (v === null || v === undefined || v === '') {
                delete fltValue[key];
              }
            });
          }

          if (isEmpty(fltValue)) {
            delete flt[filterKey];
          }
        }
      }
    }*/
    if (onChangeFilter) onChangeFilter(flt);
  };

  render() {
    const {
      getClassRow = () => {},
      showFilter = false,
      items = [],
      sort = {},
      filter = {},
      onChangeSort,
      onClickRow,
      filterDebounce
    } = this.props;

    const columns = !this.props.columns ? [] : this.props.columns.filter(a => !a.hidden);

    const renderFilter = (clmn) => {
      let filterBy = clmn.filterBy || clmn.field;
      let filterValue = filter[filterBy];
      let filterValueType = clmn.filterValueType || clmn.type;

      const handlerSelectOnChange = (e) => {
        this.handlerOnChangeFilter({...filter, [filterBy]: e.target.value});
      };

      const dateOnChange = (v) => {
        this.handlerOnChangeFilter({...filter, [filterBy]: v});
      };

      const textOnChange = (vl) => {
        this.handlerOnChangeFilter({...filter, [filterBy]: vl});
      };

      if (clmn.dict) {
        if (filterValue !== 0 && filterValue !== false && !filterValue) filterValue = '';

        return (
          <Select
            style={{width: '100%'}}
            value={filterValue}
            displayEmpty
            onChange={handlerSelectOnChange}
          >
            <MenuItem value=''><em>все</em></MenuItem>
            {Object.keys(clmn.dict).map((key) =>
              <MenuItem key={key} value={key}>{clmn.dict[key]}</MenuItem>
            )}
          </Select>
        );
      } else if (filterValueType === 'bool') {
        if (filterValue !== 0 && filterValue !== false && !filterValue) filterValue = '';

        return (
          <Select
            style={{width: '100%'}}
            value={filterValue}
            displayEmpty
            onChange={handlerSelectOnChange}
          >
            <MenuItem value=''><em>все</em></MenuItem>
            <MenuItem value={true}>Да</MenuItem>
            <MenuItem value={false}>Нет</MenuItem>
          </Select>
        );
      }

      if (filterValue !== 0 && filterValue !== false && !filterValue) filterValue = '';

      switch (filterValueType) {
        case 'date':
          switch (clmn.filterType) {
            case 'range':
              return (
                <DateFieldRange
                  dateRangeDisplayType={'column'}
                  style={{width: '100%'}}
                  onChange={(gte, lte) => dateOnChange({gte, lte})}
                  value={filterValue}
                  placeholderFrom={'С'}
                  placeholderTo={'По'}
                />);
            default: {
              const v = filterValue || {};
              return (
                <DateField
                  style={{width: '100%'}}
                  onChange={eq => dateOnChange({eq})}
                  value={v.eq}
                />
              );
            }
          }
        case 'number':
        case 'money':
          switch (clmn.filterType) {
            case 'range':
              const v = filterValue || {};
              return (
                <div className={styles.numberFilterRangeBox}>
                  <NumberField
                    style={{marginRight: '2px'}}
                    debounce={filterDebounce}
                    onChange={(a) => textOnChange({...v, gte: a})}
                    value={v && v.gte || ''}
                    placeholder={'От'}
                  />
                  <NumberField
                    style={{marginLeft: '2px'}}
                    debounce={filterDebounce}
                    onChange={(a) => textOnChange({...v, lte: a})}
                    value={v && v.lte || ''}
                    placeholder={'До'}
                  />
                </div>
              );
            default: {
              const v = filterValue || {};
              return (
                <NumberField
                  debounce={filterDebounce}
                  style={{width: '100%'}}
                  onChange={a => textOnChange({...v, eq: a})}
                  value={v.eq || ''}
                />
              );
            }
          }
        default: {
          const v = filterValue || {};
          return (
            <TextField
              debounce={filterDebounce}
              style={{width: '100%'}}
              onChange={a => textOnChange({...v, like: a})}
              type={filterValueType}
              value={v.like || ''}
            />
          );
        }
      }
    };

    return (
      <Table className={styles.table}>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                className={(cx(styles.cellContentBox, styles.cellContentColumnBox))}
                style={{minWidth: (showFilter && column.widthIfShowFilter) || column.width}}
              >
                {column.tooltip
                  ?
                  <Tooltip title={column.tooltip}>
                    <TableSortLabel
                      direction={sort.desc ? 'desc' : 'asc'}
                      onClick={() => onChangeSort && onChangeSort({by: column.field, desc: sort.by === column.field ? !sort.desc : false})}
                    >
                      {column.name}
                    </TableSortLabel>
                  </Tooltip>
                  :
                  <TableSortLabel
                    direction={sort.desc ? 'desc' : 'asc'}
                    onClick={() => onChangeSort && onChangeSort({by: column.field, desc: sort.by === column.field ? !sort.desc : false})}
                  >{column.name}</TableSortLabel>
                }
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                className={(cx(styles.cellContentBox))}
                style={{minWidth: (showFilter && column.widthIfShowFilter) || column.width}}
              >
                <TableSortLabel
                  className={styles.tableSortLabel}
                  active={sort.by === column.field} direction={sort.desc ? 'desc' : 'asc'}
                  onClick={() => onChangeSort && onChangeSort({by: column.field, desc: sort.by === column.field ? !sort.desc : false})}
                />
              </TableCell>
            ))}
          </TableRow>
          {showFilter &&
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.field}>
                <div className={styles.cellContentBox} style={{width: showFilter && column.widthIfShowFilter ? column.widthIfShowFilter : column.width}}>
                  {renderFilter(column)}
                </div>
              </TableCell>
            ))}
          </TableRow>
          }
        </TableHead>
        <TableBody>
          {items.map((row, i) => {
            const classRow = getClassRow(row, i);
            return (
              <TableRow
                className={cx(styles.row, {[styles.rowDark]: (i % 2 === 0)}, classRow)}
                key={`row-${row.id}` || `row-index-${i}`}
                onClick={() => onClickRow && onClickRow(row.id, row)}
              >
                {columns.map((column) => (
                  <TableCell
                    key={`row-${i}-column-${column.field}`}
                    className={cx(styles.cellContentBox, styles.cellContentCell)}
                    style={{width: showFilter && column.widthIfShowFilter ? column.widthIfShowFilter : column.width}}
                  >
                    {column.format
                      ? column.format(row[column.field], row, items)
                      : this.valueFormatted(row[column.field], {type: column.type, dict: column.dict})
                    }
                  </TableCell>))}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    );
  }
}

TableComponent.defaultProps = {
  filterDebounce: 300
};

TableComponent.propTypes = {
  columns: PropTypes.arrayOf({
    hidden: PropTypes.bool,
    name: PropTypes.string,
    field: PropTypes.string,
    type: PropTypes.oneOf(['bool', 'money', 'number']),
    dict: PropTypes.object,
    format: PropTypes.func,
    filterType: PropTypes.oneOf(['range']),
    width: PropTypes.string,
    widthIfShowFilter: PropTypes.string,
  }),
  items: PropTypes.array,
  sort: PropTypes.objectOf({
    by: PropTypes.string,
    desc: PropTypes.string
  }),
  filter: PropTypes.object,

  showFilter: PropTypes.bool,
  filterDebounce: PropTypes.number,

  onChangeFilter: PropTypes.func,
  onChangeSort: PropTypes.func,
  onClickRow: PropTypes.func,

  getClassRow: PropTypes.func,
};

export default TableComponent;


// WEBPACK FOOTER //
// ./src/components/common/TableComponent/TableComponent.jsx